import type { ApiWasteBatch } from '@/features/kitchen/api/getTodayWaste'
import type { WasteBatchRecord } from '@/features/kitchen/storage/wasteStorage'

export type UiWasteBatch = {
  id: string
  batchId: string
  status: ApiWasteBatch['status']
  items: {
    id: string
    productName: string
    productionDate: string
    stockSource: 'main' | 'return' | 'damaged'
    qty: number
    reason?: string
  }[]
  proposalNote: string
  executionNote: string
  photos: string[]
  updatedAt: string
  rejectionReason?: string
}

export function mapWasteBatchesToUi(batches: ApiWasteBatch[]): UiWasteBatch[] {
  return batches.map((b) => ({
    batchId: b.id,
    id: b.code || b.id,
    status: b.status,
    updatedAt: b.updated_at,
    proposalNote: b.proposal_note ?? '',
    executionNote: '',
    photos: [],
    rejectionReason: b.rejection_reason,
    items: (b.lines ?? []).map((line) => ({
      id: line.id,
      productName: line.product_name,
      productionDate: line.production_date,
      stockSource: line.stock_source === 'return' ? 'return' as const : 'main' as const,
      qty: line.qty,
      reason: line.reason,
    })),
  }))
}

export function mapWasteBatchesFromApi(batches: ApiWasteBatch[]): WasteBatchRecord[] {
  return mapWasteBatchesToUi(batches).map((b) => ({
    id: b.id,
    status: b.status,
    updatedAt: b.updatedAt,
    rejectionReason: b.rejectionReason,
    items: b.items.map((item) => ({ productName: item.productName, qty: item.qty })),
  }))
}

export function buildWasteSummaryFromBatches(
  batches: Pick<WasteBatchRecord, 'status'>[],
) {
  const drafts = batches.filter((b) => b.status === 'draft')
  const waitingHo = batches.filter((b) => b.status === 'submitted' || b.status === 'rejected')
  const readyExecute = batches.filter((b) => b.status === 'approved')

  return {
    draftCount: drafts.length,
    waitingHoCount: waitingHo.length,
    readyExecuteCount: readyExecute.length,
    rejectedCount: batches.filter((b) => b.status === 'rejected').length,
  }
}
